var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.29 32H12.2705C1.92797 32 0.222656 28.1526 0.222656 20.1257V11.8743C0.222656 3.43156 0.222655 0 12.2705 0H34.287C45.8801 0 46.3349 2.98878 46.3349 11.8743V20.1257C46.3378 29.7502 43.6303 32 34.29 32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5684 9.31934L30.9992 15.7756L18.5684 22.2707V9.31934Z",
    fill: "#30818E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4794 16.5714L18.5684 9.31934L30.9992 15.7726L29.4794 16.5714Z",
    fill: "#30818E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5873a2a500de03eb8bac3707b3b5374d.svg";
export { ForwardRef as ReactComponent };